<footer>
    <div class="container">
        <div class="footer-content">
            <div class="footer-section">
                <h3>About DHET</h3>
                <p>The Department of Higher Education and Training is committed to developing a skilled and capable workforce to support an inclusive growth path for our country.</p>
            </div>
            <div class="footer-section">
                <h3>Quick Links</h3>
                <ul>
                    <li><a routerLink="/home">Home</a></li>
                    <li><a routerLink="/scholarships">Available Scholarships</a></li>
                    <li><a href="#">Application Process</a></li>
                    <li><a href="#">Announcements</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
            <div class="footer-section">
                <h3>Contact Information</h3>
                <ul>
                    <li><i class="fas fa-phone"></i> +27 12 312 5911</li>
                    <li><i class="fas fa-envelope"></i> info@dhet.gov.za</li>
                    <li><i class="fas fa-map-marker-alt"></i> 123 Francis Baard Street, Pretoria</li>
                </ul>
            </div>
            <div class="footer-section">
                <h3>Follow Us</h3>
                <div class="social-icons">
                    <a href="#"><i class="fab fa-facebook-f"></i></a>
                    <a href="#"><i class="fab fa-twitter"></i></a>
                    <a href="#"><i class="fab fa-youtube"></i></a>
                </div>
            </div>
        </div>
        <div class="copyright">
            &copy; {{ currentDate | date: 'yyyy' }} Department of Higher Education and Training. All Rights Reserved.
        </div>
    </div>
</footer>
